import { adsData } from "../../utils"
import './AdPackages.css';

export default function AdPackages() {

  const { quickNote, mainData, importantToNote } = adsData;

  return (
    <div className='adPackages'>
      <div className="header">
        <h1> Premium Sponsored Ad Packages </h1>
        <p> (Facebook & Instagram Only) </p>
      </div>

      <div className='quick-notes'>
        <h1> {quickNote.title} </h1>
        <p> {quickNote.msg} </p>
      </div>

      <div className="plans">
        {
          mainData.map((singlePlan, singlePlanId) => {
            return (
              <div key={`singlePlanId-${singlePlanId}`}>
                <h1 className="main-title"> {singlePlan.title} </h1>
                <h2 className="main-subtitle"> {singlePlan.msg} </h2>

                <div className="singlePlan-table">
                  {
                    singlePlan.table.map((tableItem, tableItemId) => {
                      return (
                        <ul key={`tableItemId-${tableItemId}`}>
                          {
                            tableItem.map((item, itemId) => (
                              <li>
                                { item }
                              </li>
                            ))
                          }
                        </ul>
                      )
                    })
                  }
                </div>


                <div className='included-features'>
                  <h1> Included Features </h1>
                  <ul>
                    {
                      singlePlan.list.map((list, listId) => (
                        <li key={`listId-${listId}`}> {list} </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
            )
          })
        }

      </div>


      <div className="importantToNote">
        <h1 className="main-title"> {importantToNote.title} </h1>
        <ul> 
          {
            importantToNote.list.map((note, noteId) => (
              <li key={`noteId-${noteId}`}> {note} </li>
            ))
          }
        </ul>
      </div>
    </div>
  )
}
